import { api } from "./client";

/**
 * Интерфейс за отговор от фискална операция (report / cash)
 */
export interface FiscalOperationResponse {
  request_id?: string;
  printer_guid?: string;
  status?: string;
  result?: Record<string, unknown>;
  error?: string;
  /** Съобщение от фискалното устройство при успешна операция */
  message?: string;
  /** Потребител, изпълнил операцията */
  user?: string;
}

/**
 * Изпраща X отчет към фискалното устройство
 * POST /operations/x-report
 */
export const getXReport = async (): Promise<FiscalOperationResponse> => {
  const response = await api.post<FiscalOperationResponse>(
    "/operations/x-report",
  );
  return response.data;
};

/**
 * Изпраща Z отчет към фискалното устройство
 * POST /operations/z-report
 */
export const getZReport = async (): Promise<FiscalOperationResponse> => {
  const response = await api.post<FiscalOperationResponse>(
    "/operations/z-report",
  );
  return response.data;
};

/** Вид на отчета от фискалната памет: съкратен (сумите) или подробен (по Z отчет). */
export type FmReportDetail = "short" | "full";

/**
 * Входни данни за „Справка отчети за дата" — отчет от фискалната памет.
 * Датите са ISO `YYYY-MM-DD`, периодът е затворен; краят не може да е преди
 * началото (BE връща 422), край след днес гейтуеят реже до днес.
 */
export interface FmReportIn {
  detail: FmReportDetail;
  startDate: string;
  endDate: string;
}

/**
 * X отчет за период — отчет от фискалната памет (не нулира нищо)
 * POST /operations/fm-report с body { detail, startDate, endDate }
 */
export const printFmReport = async (
  data: FmReportIn,
): Promise<FiscalOperationResponse> => {
  const response = await api.post<FiscalOperationResponse>(
    "/operations/fm-report",
    data,
  );
  return response.data;
};

/**
 * Интерфейс за входните данни при служебно въвеждане/извеждане
 * amount - сумата за въвеждане/извеждане
 */
export interface CashOperationIn {
  amount: number;
}

/**
 * Служебно въвеждане (cash-in) - добавяне на пари в касата
 * POST /operations/cash-in с body { amount: number }
 */
export const cashIn = async (
  data: CashOperationIn,
): Promise<FiscalOperationResponse> => {
  const response = await api.post<FiscalOperationResponse>(
    "/operations/cash-in",
    data,
  );
  return response.data;
};

/**
 * Служебно извеждане (cash-out) - изваждане на пари от касата
 * POST /operations/cash-out с body { amount: number }
 */
export const cashOut = async (
  data: CashOperationIn,
): Promise<FiscalOperationResponse> => {
  const response = await api.post<FiscalOperationResponse>(
    "/operations/cash-out",
    data,
  );
  return response.data;
};
